<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div v-bind:class="{'large-panel':isLarge,'medium-panel':isMedium,'small-panel':isSmall}" @click.stop>
                <div class="dialog-title">
                    <slot name="title"></slot>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <slot name="body"></slot>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <slot name="button"></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            default: 'large'
        }
    },

    computed: {
        isLarge() {
            return this.size === 'large'
        },
        isMedium() {
            return this.size === 'medium'
        },
        isSmall() {
            return this.size === 'small'
        }
    }

}
</script>

<style scoped>

.dialog-modal-mask {
    position: fixed;
    z-index: 1999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.large-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 1000px;
    height: 80vh;
    margin-left: -500px;
    margin-top: -40vh;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}

.medium-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 750px;
    height: 60vh;
    margin-left: -375px;
    margin-top: -30vh;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}

.small-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 500px;
    height: 40vh;
    margin-left: -250px;
    margin-top: -20vh;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}

.dialog-title {
    padding: 8px 20px 4px 20px;
    height: 60px;
    vertical-align: middle;
    display: table-cell;
    font-size: 16px;
    font-weight: 700;
}

hr.dialog-hr {
    border: none;
    height: 1px;
    background-color: #eee;
    margin: 0.3px;
}

.dialog-body {
    height: -webkit-calc(100% - 140px);
    padding: 0;
    font-size: 14px;
    overflow: auto;
}

</style>
